var ShareButton = (function () {
    function ShareButton(provider, template, classes) {
        this.provider = provider;
        this.template = template;
        this.classes = classes;
    }
    return ShareButton;
}());
export { ShareButton };
var ShareArgs = (function () {
    function ShareArgs(url, title, description, image, tags, via, mobile) {
        this.url = url;
        this.title = title;
        this.description = description;
        this.image = image;
        this.tags = tags;
        this.via = via;
        this.mobile = mobile;
    }
    return ShareArgs;
}());
export { ShareArgs };
//# sourceMappingURL=share-buttons.class.js.map


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/node_modules/ngx-sharebuttons/helpers/share-buttons.class.js
// module id = ../../../../ngx-sharebuttons/helpers/share-buttons.class.js
// module chunks = vendor